const formatCode = (couponCode: string): string => couponCode.trimEnd();

export default formatCode;
